
angular.module('bmsApp.directives').controller('ComplaintFormCtrl', ['$scope', '$log', '$timeout', '$q', '$modalInstance', '$ngBootbox', 'ComplaintSvc', 'EmployeeOptionsSvc', 'FileSvc', 'complaint', '$window', 'viewOnly','SMJobCleaningServiceSvc', 'PhotoSvc', 'MMJobRoomSvc', function ($scope, $log, $timeout, $q, $modalInstance, $ngBootbox, ComplaintSvc, EmployeeOptionsSvc, FileSvc, complaint, $window, viewOnly, SMJobCleaningServiceSvc, PhotoSvc, MMJobRoomSvc) {

	$scope.complaint = complaint;
	$scope.viewOnly = viewOnly;

	$scope.cancel = function () {
		if($scope.viewOnly){
			$modalInstance.dismiss('cancel');
			return;
		}
		$ngBootbox.confirm('Are you sure you want to do this?')
			.then(function () {
				$modalInstance.dismiss('cancel');
			});
	};

	$scope.init = function () {
		$scope.processing = false;
		$scope.loading = true;
		var complaintTypeOptionsPromise = ComplaintSvc.complaintTypeOptions();
		var complaintStatusOptionsPromise = ComplaintSvc.complaintStatusOptions();
		var employeeOptionsPromise = EmployeeOptionsSvc.employee();

		var promises = [
			complaintTypeOptionsPromise,
			complaintStatusOptionsPromise,
			employeeOptionsPromise,
		];
		if($scope.isSM()){
			var jobCleaningServiceOptionsPromise = SMJobCleaningServiceSvc.index({
				filter: {
					job: $scope.complaint.complaintable_id,
				}
			});
			promises.push(jobCleaningServiceOptionsPromise);
		} else if ($scope.isMM()){
			var jobRoomOptionsPromise = MMJobRoomSvc.index({
				filter: {
					job: $scope.complaint.complaintable_id,
				}
			});
			promises.push(jobRoomOptionsPromise);
		}

		$q.all(promises)
			.then(function (responses) {
				$scope.complaintTypeOptions = responses[0].data.options;
				$scope.complaintStatusOptions = responses[1].data.options;
				$scope.employeeOptions = responses[2].data.options;
				if($scope.isSM()){
					$scope.jobCleaningServiceOptions = responses[3].data.job_cleaning_service_collection;
				} else if ($scope.isMM()){
					$scope.jobRoomOptions = responses[3].data.job_room_collection;
				}
				$scope.complaint.uploaded_attachments = [];
				$scope.complaint.removed_attachments = [];
				$scope.enableSubmit = true;
				$scope.loading = false;
			});
	};

	$scope.submit = function () {
		$scope.processing = true;

		var modalResult = {
			success: false
		};

		var savePromise = $scope.complaint.id ? ComplaintSvc.update($scope.complaint) : ComplaintSvc.create($scope.complaint);
		savePromise
			.then(function (response) {
				modalResult.success = response.data.success;
				modalResult.action = $scope.complaint.id ? 'update' : 'create';
				$modalInstance.close(modalResult);
			}, function (error) {
				modalResult.error = error;
				$scope.errors = error;
			})
			.finally(function () {
				$scope.processing = false;
			});
	};

	$scope.formvalidatorconfig = {
		submitHandler: function (form) {
			$scope.submit();
		},
		errorPlacement: function (error, element) {
			error.appendTo('#complaint-errors');
		},
		errorContainer: '#complaint-errors'
	};

	$scope.dropzone = {
		config: {
			url: '/api/file/upload',
			parallelUploads: 3,
			maxFileSize: 30,
			addRemoveLinks: true,
			eventHandlers: {
				success: function (file, response) {
					file.serverFilepath = response.filepath;
					$scope.complaint.removed_attachments = _.without($scope.complaint.removed_attachments, file.serverFilepath);
					if (!_.contains($scope.complaint.uploaded_attachments, file.serverFilepath)) {
						$scope.complaint.uploaded_attachments.push(file.serverFilepath);
					}
					$timeout(function () {
						$scope.$apply();
					}, 0);
				},
				drop: function (event) {
					$scope.enableSubmit = false;
					$timeout(function () {
						$scope.$apply();
					}, 0);
				},
				queuecomplete: function () {
					$scope.enableSubmit = true;
					$timeout(function () {
						$scope.$apply();
					}, 0);
				},
				removedfile: function (file) {
					FileSvc.delete(file.serverFilepath)
						.then(function (response) {
							$scope.complaint.uploaded_attachments = _.without($scope.complaint.uploaded_attachments, file.serverFilepath);
							if (!_.contains($scope.complaint.removed_attachments, file.serverFilepath)) {
								$scope.complaint.removed_attachments.push(file.serverFilepath);
							}
							$log.log('Dropzone file removed');
						}, function (error) {
							$log.error('Failed to remove dropzone file: ' + error);
						});
				}
			}
		}
	};

	$scope.toggleDeleteComplaintAttachment = function (complaint_attachment) {
		complaint_attachment.delete = complaint_attachment.delete ? false : true;
	};

	$scope.downloadAttachment = function(filename) {
		$window.open('file/download/'+filename, '_blank');
	}

	$scope.viewPhoto = PhotoSvc.showViewModal;

}]);
